import { getRequest, postRequest, putRequest } from "./performanceApiClient";

export const listCalibrations = async (params = {}) =>
  getRequest("/calibrations", { params });

export const getCalibrationById = async (calibrationId) =>
  getRequest(`/calibrations/${calibrationId}`);

export const createCalibration = async (payload) =>
  postRequest("/calibrations", payload);

export const updateCalibration = async (calibrationId, payload) =>
  putRequest(`/calibrations/${calibrationId}`, payload);

export const finalizeCalibration = async (calibrationId) =>
  postRequest(`/calibrations/${calibrationId}/finalize`, {});

export default {
  listCalibrations,
  getCalibrationById,
  createCalibration,
  updateCalibration,
  finalizeCalibration,
};
